module.exports = __webpack_public_path__ + "img/23.be629c13.jpg";